<!--
 * @Author: DouDou
 * @LastEditors: gxd
 * @Date: 2020-09-17 16:45:23
 * @LastEditTime: 2020-12-29 11:13:08
 * @Description: File description
-->
<template>
  <div class="canvas-content">
    <canvas class="saveposter-poster" :id="`myCanvas${id}`" :width="pxWidth" :height="pxHeight"></canvas>
    <img class="saveposter-posterimg" :src="canvasposterImgUrl" />
  </div>
</template>

<script>
import posterDetails from '../utils/posterType'
import QRCode from 'qrcode'

const DEFAULT_IMG = 'https://activity.xueersi.com/oss/ldxv4_1127/default01.png'

export default {
  props: {
    // canvas-id
    id: {
      type: Number,
      default: 0
    },
    // 海报的type(styleType)
    type: {
      type: Number,
      default: 1
    },
    // 海报id
    posterId: {
      type: String,
      default: ''
    },
    // 去换取海报列表的对象（后端提供）
    materiel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 海报列表（如果有列表数据则直接使用）
    posterData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 打点数据参数
    clickMsgParams: {
      type: Object,
      default: () => {
        return {
          action: 'canvasImg',
          clickid: '5.3.16'
        }
      }
    }
  },
  data () {
    return {
      canvas: '',
      pxWidth: 750,
      canvasCtx: '',
      pxHeight: 1200,
      canvasposterImgUrl: '',
      count: 1
    }
  },
  mounted () {
    this.drawCanvas()
  },
  methods: {
    resetCount (count = 1) {
      this.count = count
    },
    async drawCanvas () {
      const canvas = document.querySelector(`#myCanvas${this.id}`)
      this.canvas = canvas
      this.canvasCtx = canvas.getContext('2d')
      let materiel = []
      if (this.posterData.length) {
        materiel = this.posterData
      } else {
        materiel = posterDetails(this.type, this.materiel)
      }
      this.$xesLogger.clickMsg({
        params: {
          action: 'drawCanvas',
          materiel: JSON.stringify(materiel)
        }
      })
      for (let i = 0; i < materiel.length; i++) {
        const item = materiel[i]
        const { text } = item
        if (text || text === '') {
          this.drawTextHandler(item)
        } else {
          try {
            if (!item.url) continue
            await this.drawImageHandler(item)
          } catch (e) {
            this.$emit(
              'posterDrawed',
              this.id,
              this.posterId,
              DEFAULT_IMG
            )
            return
          }
        }
      }
      console.log('END--------绘制完成', new Date().valueOf())
      this.canvasposterImgUrl = canvas.toDataURL('image/png')
      this.$emit(
        'posterDrawed',
        this.id,
        this.posterId,
        this.canvasposterImgUrl
      )
      const params = { ...this.clickMsgParams, posterId: `${this.posterId}` }
      console.log('canvas埋点参数 =>>', params)
      this.$xesLogger.clickMsg({
        params
      })
    },
    buryingErrorPoint (url) {
      this.$xesLogger.clickMsg({
        params: {
          src: url,
          type: '没有取到需要绘制的图片',
          action: 'drawImageError'
        }
      })
    },
    drawTextHandler (params) {
      const { canvasCtx } = this
      const { x, y, width, lineNumber, lineHeight, text } = params
      // TODO: test
      // canvasCtx.fillStyle = '#FF0000'
      // canvasCtx.fillRect(x, y, width, height)
      canvasCtx.save()
      canvasCtx.font = params.font || 'bold 30px Tahoma'
      canvasCtx.fillStyle = params.textColor || '#000000'
      canvasCtx.textAlign = params.textAlign || 'left'
      // canvasCtx.textAlign = 'right'
      this.textPrewrap(canvasCtx, text, x, y, lineHeight, width, lineNumber)
    },
    drawImageHandler (params) {
      // params = params.url = 'https://activity.xueersi.com/oss/ldxv4/37.png'
      this.$xesLogger.clickMsg({
        params: {
          action: 'drawImageHandler',
          params: JSON.stringify(params)
        }
      })
      return new Promise((resolve, reject) => {
        const { canvasCtx } = this
        const {
          x,
          y,
          width,
          height,
          url,
          isAvatar = false,
          type
        } = params
        canvasCtx.save()
        console.log('imgType', params.type)
        // 创建一个Image对象，实现图片的预下载
        const img = new Image()
        img.setAttribute('crossorigin', 'anonymous')
        if (type === 'qrCode' && this.materiel.isQrCode) {
          // 当前绘制的是二维码，且二维码需要前端生成
          QRCode.toDataURL(url)
            .then(imgUrl => {
              console.log(imgUrl)
              if (!imgUrl) this.buryingErrorPoint(imgUrl)
              img.src = imgUrl
            })
            .catch(err => {
              console.error(err)
              img.src =
                'https://activity.xueersi.com/oss/ldxv4_1127/qrcode.jpeg'
              this.$xesLogger.clickMsg({
                params: {
                  src: img.src,
                  type: params.type,
                  action: 'qrcodeError'
                }
              })
            })
        } else {
          if (!url) this.buryingErrorPoint(url)
          img.src = url
        }
        // 图片下载完成后续处理
        const imgDraw = () => {
          this.resetCount(1)
          if (isAvatar) {
            const r = width / 2
            canvasCtx.arc(x + r, y + r, r, 0, 2 * Math.PI)
            canvasCtx.clip()
            canvasCtx.drawImage(img, x, y, width, height)
            canvasCtx.restore()
            resolve()
            return
          }
          // 设置了图片的宽度和高度
          if (width) {
            canvasCtx.drawImage(img, x, y, width, height)
          } else {
            // 图片比画布宽，等比缩放
            if (img.width > this.pxWidth) {
              const scaleWidth = this.pxWidth
              const scaleHeight = (scaleWidth * img.height) / img.width
              canvasCtx.drawImage(img, x, y, scaleWidth, scaleHeight)
            } else {
              canvasCtx.drawImage(img, x, y)
            }
          }
          canvasCtx.restore()
          console.log('imgggggg', img)
          resolve()
        }
        img.onload = imgDraw
        img.onerror = e => {
          console.log('=======onerror', e, img, params)
          this.$xesLogger.clickMsg({
            params: {
              count: this.count,
              src: url,
              type: params.type + (url === DEFAULT_IMG ? '-default' : ''),
              action: 'imgError',
              params: JSON.stringify(params)
            }
          })
          if (this.count === 1) {
            this.resetCount(2)
            img.src = url
            return
          }
          console.log('=======error')
          this.resetCount(1)
          if (params.type === 'qrCode') {
            img.src = 'https://activity.xueersi.com/oss/ldxv4_1127/qrcode.jpeg' // 默认二维码
          } else if (params.type === 'avatar') {
            img.src = 'https://activity.xueersi.com/oss/ldxv4_1127/avatar.png' // 默认头像
          } else if (params.type === 'bgImg') {
            // img.src =
            //   'https://activity.xueersi.com/oss/ldxv4_1127/default01.png'
            // this.$emit(
            //   'posterDrawed',
            //   this.id,
            //   this.posterId,
            //   'https://activity.xueersi.com/oss/ldxv4_1127/default01.png'
            // )
          }

          console.log('img.src', img.src)
          // eslint-disable-next-line
          reject()
        }
      })
      // }
    },
    // 文字自动换行
    textPrewrap (ctx, content, drawX, drawY, lineHeight, lineMaxWidth, lineNum) {
      let drawTxt = '' // 当前绘制的内容
      let drawLine = 1 // 第几行开始绘制
      let drawIndex = 0 // 当前绘制内容的索引
      drawY += lineHeight // 坐标修正
      // 判断内容是否可以一行绘制完毕
      if (ctx.measureText(content).width <= lineMaxWidth) {
        ctx.fillText(content.substring(drawIndex, content.length), drawX, drawY)
      } else {
        for (let i = 0; i < content.length; i++) {
          drawTxt += content[i]
          if (ctx.measureText(drawTxt).width >= lineMaxWidth) {
            if (drawLine >= lineNum) {
              ctx.fillText(
                content.substring(drawIndex, i) + '...',
                drawX,
                drawY
              )
              break
            } else {
              ctx.fillText(content.substring(drawIndex, i + 1), drawX, drawY)
              drawIndex = i + 1
              drawLine += 1
              drawY += lineHeight
              drawTxt = ''
            }
          } else {
            // 内容绘制完毕，但是剩下的内容宽度不到lineMaxWidth
            if (i === content.length - 1) {
              ctx.fillText(content.substring(drawIndex), drawX, drawY)
            }
          }
        }
      }
    }
  }
}
</script>
